<template>
 <DefaultLayout>
  <div id="home">


  

  


<main id="main-content"
      class="main-content"
      tabindex="-1"
      aria-label="Main content of the homepage">

<ChartAnalysisSection
  @cloud-click="handleCloudClick"
  @image-selected="handleImageUpload"
/>
  <section class="top-cards"
           aria-label="File upload section">

    <!-- 🟠 파일 업로드 카드 -->
    <div class="card">

      <UploadSection @image-uploaded="handleImageUpload" />

    </div>

  </section>

      <!-- 🔹 오른쪽 상단 로고 그룹
    <div class="corner-logo-group">
      <img src="@/assets/logo/google.png" alt="Google 로고" class="corner-logo">
      <img src="@/assets/logo/dot_1.png" alt="Dot Inc 로고" class="corner-logo">
      <img src="@/assets/logo/hyu.png" alt="한양대학교 로고" class="corner-logo">
    </div> -->

</main>

<footer class="logo-footer"
        aria-label="Footer with organization logos and names">
  <div class="logo-left">
    <img src="@/assets/logo/google.png" alt="Google 로고" class="corner-logo">
    <img src="@/assets/logo/dot_1.png" alt="Dot Inc 로고" class="corner-logo">
    <img src="@/assets/logo/hyu.png" alt="한양대학교 로고" class="corner-logo">
  </div>

  <div class="logo-right">
    Google x Dot Inc. x HYU
  </div>
</footer>

  </div>
  <Device v-model="isModalShown" />
  
  </DefaultLayout>
  
</template>

<script>
import ChartAnalysisSection from "@/components/ChartAnalysisSection.vue"
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { defineAsyncComponent} from "vue"
import HeaderComponent from '@/components/HeaderComponent.vue'
import UploadSection from '@/components/UploadSection.vue'
import InfoSection from '@/components/InfoSection.vue'
import ApiService from '@/services/ApiService.js'
import { DotpadList } from "@/js/dot/DotpadList.js";
import { connectChatWS, onChatWS, sendChatJSON, isChatOpen } from "@/socket/socket.js";

import axios from "axios";

const Device = defineAsyncComponent(() => import("@/components/dialog/DeviceDialog.vue"));

const printPixels = (pixels) => {
    console.log('🚀 printPixels 함수 호출');
    const dotpadList = DotpadList.getList();
    console.log('현재 DotpadList:', dotpadList);
    console.log('전달된 픽셀 데이터:', pixels);
    if (dotpadList.length > 0) {
        for (const dotPad of dotpadList) {
            dotPad.dotpadSDK.Load_mapFile(pixels);
            dotPad.dotpadSDK.Make_DTM_Data();
            dotPad.dotpadSDK.sendPixelPattern();
        }
    }
}
let  labels = [];


export default {
  name: 'HomePage',
  components: {
    ChartAnalysisSection,
    DefaultLayout,
    HeaderComponent,
    UploadSection,
    InfoSection,
    Device,
  },

  data() {
    return {
      groups: [],  // 닷캔버스
      selectedFileKey: "", // 닷캔버스

      // 클라우드 이미지 드롭다운용
      cloudImages: [],          // { id, name } 형식의 배열을 기대
      selectedCloudImageKey: "",

      apiServerStatus: 'checking',// checking, connected, disconnected
      isModalShown: false,
      webviewStatus: 'checking',  // ← 누락되어 있었음
      ours: true,                 // ← 이것도 추가
      // 사용자 입력 관련
      userInput: '',
      savedUserInfo: '',
      //점자 번역
      tx: "",      // 입력 텍스트
      out: null,
      
    }
  },
created() {

},

  async mounted() {

  },
  methods: {
    //닷 캔버스 연결 함수 >
async goToDotCanvas() {
  if (!this.selectedFileKey) return;

  // localStorage에 저장


  this.$router.push({
    name: "dotCanvas",
    query: { fileKey: this.selectedFileKey }
  });
},
 

  async goToCloudImage() {
  if (!this.selectedCloudImageKey) return;

  const selected = this.cloudImages.find(
    img => img.id === this.selectedCloudImageKey
  );
  console.log("선택된 클라우드 이미지:", selected);

  // TODO: 이 아래에서 원하는 동작 수행
  // 예: 이미지 상세 페이지로 이동, 분석 요청, DotPad 출력 등
  // this.$router.push({ name: "CloudImageDetail", query: { id: selected.id } });
},




    //점자 관련
    runTranslate() {
      const text = String(this.tx ?? "");
      // '함수 실행만' 요구: translate가 있으면 실행, 없으면 입력 텍스트 그대로 반환
      this.out = typeof this.translate === "function" ? this.translate(text) : text;

    },
    translate(text) {
      ApiService.translate(text).then(response => {
        let labels = response["text"];
        const dotpadList = DotpadList.getList();
      if (dotpadList.length > 0) {
      for (const dotPad of dotpadList) {
        function padHex(data, totalLen) {
          return data.padEnd(totalLen, "0");
        }

        const filled = padHex(labels, 40);
        // 하단 20셀에 출력
        dotPad.dotpadSDK.dotPadSendModule.setDotPadLineCommand(0, "80", "00", filled);
        dotPad.dotpadSDK.dotPadSendModule.setRefreshMode("TEXT_DISPLAY");
        dotPad.dotpadSDK.dotPadSendModule.sendCommand();
      }
    }

      }).catch(error => {
        console.error('AI 요청 실패:', error);
        this.chatLoading = false;
      });
    },

    // 사용자 정보 관리 메서드
    saveUserInfo() {
      if (!this.userInput.trim()) return
      
      const userInfo = this.userInput.trim()
      localStorage.setItem('userInfo', userInfo)
      this.savedUserInfo = userInfo
      this.userInput = ''
      
      console.log('✅ 사용자 정보 저장됨:', userInfo)
    },
    
    loadUserInfo() {
      const saved = localStorage.getItem('userInfo')
      if (saved) {
        this.savedUserInfo = saved
        console.log('📂 저장된 사용자 정보 불러옴:', saved)
      }
    },
    
    clearUserInfo() {
      localStorage.removeItem('userInfo')
      this.savedUserInfo = ''
      console.log('🗑️ 사용자 정보 삭제됨')
    },

    selectOurs() {
      this.ours = true;
      // localStorage에 상태 저장
      localStorage.setItem('oursBaselineState', 'ours');
      console.log('✅ Ours 상태 저장됨');
    },
    selectBaseline() {
      this.ours = false;
      // localStorage에 상태 저장
      localStorage.setItem('oursBaselineState', 'baseline');
      console.log('✅ Baseline 상태 저장됨');
    },

    // ours/baseline 상태 불러오기
    loadOursBaselineState() {
      const saved = localStorage.getItem('oursBaselineState');
      if (saved) {
        this.ours = saved === 'ours';
        console.log('📂 저장된 Ours/Baseline 상태 불러옴:', saved);
      }
    },
    flattenArray(originalArray, targetWidth, targetHeight) {
      const flattenedArray = new Array(targetWidth * targetHeight).fill(0);

      const inputWidth = originalArray[0].length;
      const inputHeight = originalArray.length;

      const startX = Math.floor((targetWidth - inputWidth) / 2);
      const startY = Math.floor((targetHeight - inputHeight) / 2);

      for (let y = 0; y < inputHeight; y++) {
        for (let x = 0; x < inputWidth; x++) {
          const index = (startY + y) * targetWidth + (startX + x);
          flattenedArray[index] = originalArray[y][x];
        }
      }

      return flattenedArray;
    },
    async checkWebViewStatus() {
      try {
        console.log('🚀 WebView2 상태 확인...')
        
        // 전역 Hybrid 인스턴스 사용
        if (this.$hybrid && this.$hybrid.isWebViewAvailable()) {
          console.log('✅ WebView2 감지됨')
          this.webviewStatus = 'available'
        } else {
          console.log('❌ WebView2를 사용할 수 없습니다.')
          this.webviewStatus = 'unavailable'
        }
      } catch (error) {
        console.error('❌ WebView2 상태 확인 실패:', error)
        this.webviewStatus = 'unavailable'
      }
    },

    async checkApiServerStatus() {
      try {
        console.log('🚀 FastAPI 서버 상태 확인...')
        
        const healthResponse = await ApiService.healthCheck()
        console.log('✅ FastAPI 서버 연결됨:', healthResponse)
        this.apiServerStatus = 'connected'
      } catch (error) {
        console.error('❌ FastAPI 서버 연결 실패:', error)
        this.apiServerStatus = 'disconnected'
      }
    },
    
    async handleImageUpload(imageData) {

        var image = {
          objectType: imageData.objectType,
          file: imageData.file,
          filename: imageData.originalFile ? imageData.originalFile.name : imageData.name
        }
        // ImageData 인터페이스 구조 확인
        
        //Sa2VA로 이동
        console.log('ImageData 속성:', image )
        // ApiService.analyzeImage(image.file)
        //   .then(response => {
        //     console.log('AI 분석 결과:', response);
        //     labels = response;
        //     console.log('AI 분석 결과:', labels);
        //     labels = this.flattenArray(labels, 60, 40);
        //     printPixels(labels);

        //   })
        //   .catch(error => {
        //     console.error('AI 분석 실패:', error);
        //   });

        // WebView2 환경에서 AI 분석
        if (this.$hybrid && this.$hybrid.isWebViewAvailable()) {
          console.log('🤖 AI 분석 시작...')
          
        try {
            // AI 가능 여부 먼저 확인
            const result = await this.$hybrid.send("image", "이미지 분석", image, 10000);
            console.log("🎯 AI 분석 결과:", result);

            // 받은 값에서 정보 추출
            const processedImageData = {
              id: result.id,
              rId: result.id, // 동일 ID 사용 (필요 시 분리)
              objectType: result.objectType,
              file: result.image, // base64 이미지 (data URL)
              name: result.filename,
              size: null, // 필요 시 분석해서 넣기
              isUploaded: true,
              isAnalyzed: true,
              analyzed: result // 전체 분석 결과를 그대로 보낼 수도 있음
            };
            console.log('AI 분석 완료:', processedImageData);
            
            // ImageDetail 페이지로 이동
            this.$router.push({
              name: 'ImageDetail',
              params: { id: processedImageData.id },
              query: { 
                rId: processedImageData.rId,
                objectType: processedImageData.objectType,
                file: processedImageData.file,
                name: processedImageData.name,
                size: processedImageData.size,
                isUploaded: processedImageData.isUploaded,
                isAnalyzed: processedImageData.isAnalyzed,
                analyzed: JSON.stringify(processedImageData.analyzed),
                ours_or_baseline: this.ours ? '1' : '0'// JSON 문자열로 변환
              }
            })

        } catch (aiError) {
            console.error('❌ AI 분석 실패:', aiError);
            
            // AI 분석 실패 시에도 ImageDetail로 이동 (원본 데이터 사용)
            this.$router.push({
              name: 'ImageDetail',
              params: { id: imageData.id },
              query: { 
                rId: imageData.rId,
                objectType: imageData.objectType,
                file: imageData.file,
                name: imageData.name,
                size: imageData.size,
                isUploaded: false,
                isAnalyzed: false,
                analyzed: JSON.stringify({ error: aiError.message }),
                hasError: true,
                ours_or_baseline: this.ours ? '1' : '0'
              }
            })
        }
      } else {
        // WebView2 환경이 아닐 때도 ImageDetail로 이동
        console.log('ℹ️ WebView2 환경이 아니므로 AI 분석 생략')
        this.$router.push({
          name: 'ImageDetail',
          params: { id: imageData.id },
          query: { 
            rId: imageData.rId,
            objectType: imageData.objectType,
            file: imageData.file,
            name: imageData.name,
            size: imageData.size,
            isUploaded: false,
            isAnalyzed: false,
            ours_or_baseline: this.ours ? '1' : '0',
            analyzed: JSON.stringify({ info: '분석 대기 중' })
          }
        })
      }
    },

    async handleTextUpload() {
        const text = this.tx
        console.log('textData 속성:', text )
         try {

          this.$router.push({
            name: 'TextDetail',
            query: { 
              text: text, 
              isUploaded: false,
              isAnalyzed: false,
              ours_or_baseline: this.ours ? '1' : '0'
            }
          })
      } catch (aiError) {
            console.error('❌ AI 분석 실패:', aiError);

      }
    
    },
    async handleQAUpload() {
        const text = this.tx
        console.log('textData 속성:', text )
         try {

          this.$router.push({
            name: 'QADetail',
            query: { 
              text: text, 
              isUploaded: false,
              isAnalyzed: false,
              ours_or_baseline: this.ours ? '1' : '0'
            }
          })
      } catch (aiError) {
            console.error('❌ AI 분석 실패:', aiError);

      }
    
    },



  }
}

</script>

<style>
/* 글로벌 스타일은 별도 파일로 분리됨 */
@import '../assets/styles/global.css';

.webview-status {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  border-bottom: 1px solid #e0e0e0;
}

.webview-status.checking {
  background-color: #fff3cd;
  color: #856404;
}

.webview-status.available {
  background-color: #d4edda;
  color: #155724;
}

.webview-status.unavailable {
  background-color: #f8d7da;
  color: #721c24;
}
.dotpad {
  background-color: #FB6D3A;
  border-radius: 10px;
  width: 64px;
  height: 60px;
  min-width: 64px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.dotpad:active {
  opacity: 0.8;
}

.api-status {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.9rem;
  font-weight: 500;
  border-bottom: 1px solid #e0e0e0;
}

.api-status.checking {
  background-color: #fff3cd;
  color: #856404;
}

.api-status.connected {
  background-color: #d4edda;
  color: #155724;
}

.api-status.disconnected {
  background-color: #f8d7da;
  color: #721c24;
}

.status-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 1rem 2rem; /* 🔹 크기 키움 */
  margin-right: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.2rem; /* 🔹 글씨 크게 */
  font-weight: bold;
  transition: background 0.3s ease;
}

.status-btn:hover {
  background: #2980b9;
}

.status-btn.active {
  background: #2ecc71; /* 선택된 버튼 색상 */
}

/* 사용자 정보 입력 섹션 스타일 */
.user-info-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin: 1rem 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e3f2fd;
}

.user-info-section h3 {
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
}

.user-input-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.input-group label {
  font-weight: 600;
  color: #34495e;
  min-width: 80px;
}

.user-input {
  flex: 1;
  padding: 0.75rem;
  border: 2px solid #e3f2fd;
  border-radius: 8px;
  font-size: 1rem;
  min-width: 200px;
  transition: border-color 0.3s ease;
}

.user-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}

.save-btn {
  background: #27ae60;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.save-btn:hover:not(:disabled) {
  background: #219a52;
  transform: translateY(-1px);
}

.save-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  transform: none;
}

.saved-info {
  background: #d5f4e6;
  border: 1px solid #27ae60;
  border-radius: 8px;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.saved-label {
  font-weight: 600;
  color: #27ae60;
}

.saved-value {
  background: #27ae60;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
}

.clear-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.clear-btn:hover {
  background: #c0392b;
}

/* 새로운 ImageData 관련 스타일 */
.analysis-status {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
/* ===== 선생님 파일 선택 박스 스타일 ===== */
.file-select-box {
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);

  max-width: 1150px;        /* ✅ 박스 가로폭: 적당히 작은 카드 */
  margin-left: auto;       /* 가운데 정렬 */
  margin-right: auto;      /* 가운데 정렬 */
}

/* 타이틀/설명 영역 */
.file-select-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.file-select-title {
  font-size: 35px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  text-align: left;
}

.file-select-sub {
  font-size: 30px;
  color: #6b7280;
  margin: 0;
  justify-content: center;
}

/* 드롭다운 컨트롤 영역 */
.file-select-control {
  margin-top: 15px;
  display: flex;
  justify-content: left;
}

/* 셀렉트 박스 스타일 */
.file-select-select {
  width: 100%;
  max-width: 500px;
  padding: 12px 12px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  font-size: 18px;
  color: #111827;
  outline: none;
  cursor: pointer;

  /* 기본 셀렉트 화살표 제거 + 커스텀 화살표 */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236b7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px 8px;
  padding-right: 30px; /* 화살표 자리 확보 */
}

.file-select-select:hover {
  background-color: #f3f4f6;
}

.file-select-select:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 1px rgba(79, 70, 229, 0.18);
}
.open-btn:focus {
  outline: 3px solid #2563eb;
  outline-offset: 2px;
}

.file-select-select:disabled {
  cursor: not-allowed;
  background-color: #f9fafb;
  color: #9ca3af;
}

/* 검색 입력 및 액션 버튼 */
.file-search {
  margin: 8px 0 12px;
}
.file-search-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
}
.file-select-actions {
  display: flex;
  gap: 8px;
  margin-left: 12px;
}
.open-btn, .preview-btn {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  cursor: pointer;
  font-weight: 600;
}
.open-btn[disabled], .preview-btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
.open-btn:focus, .preview-btn:focus, .file-select-select:focus, .file-search-input:focus {
  outline: 3px solid rgba(59,130,246,0.18);
  outline-offset: 2px;
}

.file-select-desc {
  margin-top: 8px;
  color: #6b7280;
  font-size: 0.95rem;
}

.sr-only { /* simple screen-reader utility */
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

/* 파일 개수 텍스트 */
.file-select-meta {
  margin-top: 8px;
  font-size: 18px;
  color: #9ca3af;
  text-align: center;
}

.upload-area:focus {
  outline: 3px solid #3498db;
  outline-offset: 4px;
}

.image-item:focus {
  outline: 2px solid #3498db;
  outline-offset: 3px;
}

.logo-bar {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: flex-start;
  padding-left: 2rem;
  margin-bottom: 0.5rem;
}

#home {
  position: relative; /* 🔹 corner-logo-group가 이 안 기준으로 위치하게 */
}

/* 오른쪽 상단 로고 묶음 */
.corner-logo-group {
  position: static;
  bottom: 15px;
  left: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 20;          /* 헤더/버튼 위에 올라오도록 */
  pointer-events: none; /* 실수 클릭 방지 (클릭 필요하면 지워도 됨) */
}

/* 각 로고 스타일 */
.corner-logo {
  height: 40px;
  object-fit: contain;
  opacity: 0.9;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.18));
}

/* 모바일에서 살짝 작게 */
@media (max-width: 768px) {
  .corner-logo-group {
    bottom: 15px;
    left: 10px;
    gap: 6px;
  }

  .corner-logo {
    height: 22px;
  }
}

/* 한 행에 두 칼럼 배치 */
.file-select-row {
  display: flex;
  gap: 20px;
  margin-top: 12px;
  flex-wrap: wrap;              /* 화면 작아지면 아래로 떨어지게 */
}

/* 각 칼럼 */
.file-select-col {
  flex: 1 1 260px;             /* 최소 260px, 여유되면 균등 확장 */
  min-width: 260px;
}

/* 이미 있는 .file-select-sub를 칼럼 제목용으로 활용 */
.file-select-sub {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 4px 0;
  text-align: left;
}

/* 가운데 정렬만 유지하고 싶으면 file-select-control는 그대로 사용해도 됨 */
.file-select-control {
  margin-top: 8px;
  display: flex;
  justify-content: left;  /* 필요에 따라 center → flex-start로 변경도 가능 */
}

.logo-footer {
  width: 100%;
  padding: 18px 24px;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-right {
  color: #44403F;
  font-size: 32px;
  font-weight: 700;
  white-space: nowrap;
}

</style>
